import * as gdeTransactions from '../services/firestore/gdeTransactions'
import { isLoggedIn } from '../redux/global'
// import { recordLogout, recordLogin } from '../services/firestore/login'

/* eslint-disable no-console */
let consoleOn = false
if (process.env.NODE_ENV === 'production') {
  consoleOn = false
}

const timeKey = 'keyedTime'
const keysKey = 'keyStrokeCount'
const createdTime = 'createdTs'
const recordCount = 'totalRecordCount'
const boxCount = 'totalBoxCount'
const exception = 'isException'
const boxIdNo = 'boxId'
const metricsFileName = 'metricsFileId'
const isDeleted = 'isDeleted'

let keystrokes = []
let recordKeystrokes = false
let keystrokeDataObject = {}
let startTime

let doubleKeystrokes = []
let recordDoubleKeystrokes = false
let doubleKeystrokeDataObject = {}

window.addEventListener('beforeunload', function (e) {
  if (!recordKeystrokes && !recordDoubleKeystrokes && !isLoggedIn()) {
    return
  }

  // recordLogout()
  // recordLogin()
  const confirmationMessage = 'You have productivity data to save, click Cancel.';


  (e || window.event).returnValue = confirmationMessage
  return confirmationMessage
})

export const recordKeystroke = () => {
  if (consoleOn) {
    console.log('recordKeystroke', recordKeystrokes, recordDoubleKeystrokes, recordKeystrokes)
  }
  if (recordDoubleKeystrokes) {
    doubleKeystrokes.push((new Date()).getTime())
  } else if (recordKeystrokes) {
    keystrokes.push((new Date()).getTime())
  }
}

export const saveKeyStrokeData = async (isAddFileCount, boxId, fileCount = 0, totalBoxCount = 0, isException = false) => {
  const endTime = new Date().getTime()
  if (keystrokes.length === 0) {
    if (consoleOn) {
      console.log('No keystrokes to save')
    }
    return
  }

  if (boxId === '' || boxId === undefined || boxId === null) {
    totalBoxCount = 0
  }

  keystrokeDataObject[timeKey] = Math.round((endTime - startTime) / 1000)
  keystrokeDataObject[keysKey] = keystrokes.length
  keystrokeDataObject[createdTime] = new Date()
  keystrokeDataObject[recordCount] = isAddFileCount === false ? 0 : fileCount
  keystrokeDataObject[boxCount] = totalBoxCount
  keystrokeDataObject[exception] = isException
  keystrokeDataObject[boxIdNo] = boxId
  keystrokeDataObject[metricsFileName] = Date.now()
  keystrokeDataObject[isDeleted] = false

  if (consoleOn) {
    console.log('saveKeyStrokeData', keystrokeDataObject)
  }

  // Make backend call to save productivity data.
  await gdeTransactions.saveMetricsData(keystrokeDataObject)


  keystrokes = []
}

/**
 * @function
 * @description Turns on keystroke recording.
 * @param {object} obj Object for the backend to indicate the activity being performed.
 * @returns {void}
 */
export const turnOnKeystrokeRecorder = obj => {
  startTime = new Date().getTime()
  if (consoleOn) {
    console.log('turnOnKeystrokeRecorder', obj)
  }
  if (process.env.NODE_ENV !== 'production') {
    if (recordKeystrokes) {
      throw new Error('turnOnKeystrokeRecorder: You did not call turnOffKeystrokeRecorder before calling turnOnKeystrokeRecorder again.')
    }
  }
  keystrokeDataObject = { ...obj }
  recordKeystrokes = true
}

export const saveMetricsData = async (isAddFileCount, boxId, fileCount = 0, totalBoxCount = 0, isException = false, obj = {}) => {
  const endTime = new Date().getTime()
  const keyingTime = isException ? 0 : Math.round((endTime - startTime) / 1000)

  if (Object.keys(obj).length > 0) {
    keystrokeDataObject = { ...obj }
  }

  if (boxId === '' || boxId === undefined || boxId === null) {
    totalBoxCount = 0
  }
  
  keystrokeDataObject[timeKey] = keyingTime || 0
  keystrokeDataObject[keysKey] = 0
  keystrokeDataObject[createdTime] = new Date()
  keystrokeDataObject[recordCount] = isAddFileCount === false ? 0 : fileCount
  keystrokeDataObject[boxCount] = totalBoxCount
  keystrokeDataObject[exception] = isException
  keystrokeDataObject[boxIdNo] = boxId
  keystrokeDataObject[metricsFileName] = Date.now()
  keystrokeDataObject[isDeleted] = false
  if (consoleOn) {
    console.log('saveKeyStrokeData', keystrokeDataObject)
  }

  await gdeTransactions.saveMetricsData(keystrokeDataObject)
  recordKeystrokes = false
  keystrokes = []
}
 
// eslint-disable-next-line
/**
 * @param {number} fileCount fileCount
 * @param {number} boxCount boxCount
 * @param {boolean} isException if the box marked as exception
 * @function
 * @description Turns off keystroke recording and save the productivity metrics to the backend.
 * @returns {void}
 */
export const turnOffKeystrokeRecorder = async (isAddFileCount, boxId, fileCount = 0, boxCount = 0, isException = false) => {
  if (consoleOn) {
    console.log('turnOffKeystrokeRecorder')
  }
  recordKeystrokes = false
  await saveKeyStrokeData(isAddFileCount, boxId, fileCount, boxCount, isException)
}

export const saveDoubleKeyStrokeData = async (fileCount) => {
  if (doubleKeystrokes.length === 0) {
    if (consoleOn) {
      console.log('No doubleKeystrokes to save')
    }
    return
  }

  const timeInSeconds = Math.round((doubleKeystrokes[doubleKeystrokes.length - 1] - doubleKeystrokes[0]) / 1000)
  doubleKeystrokeDataObject[timeKey] = timeInSeconds
  doubleKeystrokeDataObject[keysKey] = keystrokes.length
  doubleKeystrokeDataObject[createdTime] = new Date()
  doubleKeystrokeDataObject[isDeleted] = false


  if (consoleOn) {
    console.log('saveKeyStrokeData', doubleKeystrokeDataObject)
  }

  // Make backend call to save productivity data.
  gdeTransactions.saveMetricsData(doubleKeystrokeDataObject)
  
  doubleKeystrokes = []
}

/**
 * @function
 * @description Turns on double keystroke recording.
 * @param {object} obj Object for the backend to indicate the activity being performed.
 * @returns {void}
 */
export const turnOnDoubleKeystrokeRecorder = obj => {
  if (consoleOn) {
    console.log('turnOnKeystrokeRecorder', obj)
  }
  if (process.env.NODE_ENV !== 'production') {
    if (recordDoubleKeystrokes) {
      throw new Error('turnOnDoubleKeystrokeRecorder: You did not call turnOffKeystrokeRecorder before calling turnOnKeystrokeRecorder again.')
    }
  }
  doubleKeystrokeDataObject = { ...obj }
  recordDoubleKeystrokes = true
}

/**
 * @function
 * @description Turns off double keystroke recording and save the productivity metrics to the backend.
 * @param {number} fileCount fileCount 
 * @returns {void}
 */
export const turnOffDoubleKeystrokeRecorder = async (fileCount) => {
  if (consoleOn) {
    console.log('turnOffDoubleKeystrokeRecorder')
  }
  recordDoubleKeystrokes = false
  await saveDoubleKeyStrokeData()
}

export { recordKeystrokes, recordDoubleKeystrokes, keystrokes }
